import { chakra, ImageProps, forwardRef } from '@chakra-ui/react';
// TODO: We should use one SVG for logos and change color via props
const Logo = forwardRef<ImageProps, 'img'>((props, ref) => (
  <chakra.img src="/logo.svg" ref={ref} {...props} />
));

export default Logo;
